import {Component, Input, OnChanges} from '@angular/core';

import { Rule } from '../services/capd.model';

declare var JsDiff: any;

@Component({
  selector: 'update-detail',
  templateUrl: './update-detail.component.html',
  // inputs: ['rule', 'oldRule', 'op']
})

export class UpdateDetailComponent implements OnChanges {

  @Input() rule: Rule;
  @Input() oldRule: Rule = null;
  customRule: Rule = null;
  @Input() op: string;
  customize = false;

  newVer: string;
  oldVer: string;

  custTitle: string;
  custText: string;

  constructor() { }

  ngOnChanges() {
    this.newVer = this.rule.contentPackage_id.split('-')[1];
    this.oldVer = this.oldRule.contentPackage_id.split('-')[1];

    this.custTitle = this.rule.action.messageTitle;

    if (this.op === 'c') {
      this.custTitle = '';
      this.custText = '';
      const titleDiff = JsDiff.diffWords(this.oldRule.action.messageTitle, this.rule.action.messageTitle);
      titleDiff.forEach(part => {
        if (part.removed) {}
        else if (part.added) {
          this.custTitle += '<span style="background-color:#ff0;">' + part.value + '</span>';
         }
        else { this.custTitle += part.value; }
      });
      if (this.oldRule.action.actionType === 'Message' && this.rule.action.actionType === 'Message') {
        const messageDiff = JsDiff.diffWords(this.oldRule.action.messageText, this.rule.action.messageText);
        messageDiff.forEach(part => {
          if (part.removed) {}
          else if (part.added) {
            this.custText += '<span style="background-color:#ff0;">' + part.value + '</span>';
          }
          else { this.custText += part.value; }
      }); }

      this.customRule = JSON.parse(JSON.stringify(this.rule));
      this.customRule.action.messageTitle = this.custTitle;
      this.customRule.action.messageText = this.custText;
    }
  }
}
